import React, { useMemo, useState } from 'react'
import Table from '../common/Table/Table'
import { FilterBar } from './filter-barNew'
import { applyFilterState, createFilterState } from '../../lib/reportNew/filter-stateNew'

/**
 * Convierte los filterFields legacy de una tabla al formato de metadatos del
 * motor de filtros nuevo, para que FilterBar/FilterBuilder puedan consumirlos
 * (tipos select/multiselect/cards se tratan como enum; objectProp y labelMap
 * se conservan).
 */
export function filterFieldsToFieldsNew(filterFields) {
  return (filterFields ?? [])
    .map(({ key, label, type, objectProp, labelMap, dateOperator }) => {
      if (!key || !label) return null
      return {
        key: String(key),
        label,
        type:
          type === 'number'
            ? 'number'
            : type === 'date'
              ? 'date'
              : type === 'text'
                ? 'text'
                : 'enum',
        group: 'Filtros',
        ...(objectProp ? { objectProp } : {}),
        ...(labelMap ? { labelMap } : {}),
      }
    })
    .filter(Boolean)
}

/**
 * Tabla legacy envuelta con la barra de filtros del nuevo motor.
 *
 * Sustituye a <Table> sin tocar su implementación: calcula las filas filtradas
 * con el motor filtersNew y se las pasa a la tabla. Los filtros nativos de la
 * tabla (búsqueda propia + drawer de Filtros) quedan desactivados de forma
 * predeterminada porque la FilterBar los cubre.
 *
 *   <TableWithFilters
 *     dataTable={obras}
 *     quickFields={['obra', 'provincia', 'estado']}   // campos por defecto del apartado
 *     fieldsNew={[...]}                               // opcional; si no, se derivan de filterFields
 *     // ... el resto de props que antes iban a <Table>
 *   />
 */
export default function TableWithFilters({
  ref,
  quickFields,
  fieldsNew,
  showAdvanced = true,
  disableNativeFilters = true,
  filterFields,
  searchTerms,
  ...tableProps
}) {
  const rows = tableProps.dataTable || []

  const fields = useMemo(() => fieldsNew || filterFieldsToFieldsNew(filterFields), [fieldsNew, filterFields])

  const quick = useMemo(
    () => quickFields || (filterFields ?? []).map((field) => String(field.key)),
    [quickFields, filterFields]
  )

  const [filterState, setFilterState] = useState(() => createFilterState(quick))

  const filteredRows = useMemo(
    () => applyFilterState(rows, filterState, fields),
    [rows, filterState, fields]
  )

  const tableNativeProps = disableNativeFilters
    ? { filterFields: undefined, searchTerms: undefined }
    : { filterFields, searchTerms }

  return (
    <div className="table-with-filters flex flex-col gap-4">
      <FilterBar
        rows={rows}
        state={filterState}
        onChange={setFilterState}
        resultCount={filteredRows.length}
        totalCount={rows.length}
        fields={fields}
        showAdvanced={showAdvanced}
      />
      <Table ref={ref} {...tableProps} {...tableNativeProps} dataTable={filteredRows} />
    </div>
  )
}